import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-5 pb-lg-10" }
const _hoisted_3 = { class: "fw-bolder d-flex align-items-center text-dark-blue border-bottom" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "fw-bold text-dark-blue mt-5"
}
const _hoisted_6 = { class: "fv-row" }
const _hoisted_7 = {
  key: 0,
  class: "col-lg-12 fv-row border-bottom mb-5 border-2"
}
const _hoisted_8 = { class: "fw-bolder text-dark-blue" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "fw-bold text-uppercase"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "col-lg-12 fv-row" }
const _hoisted_13 = { class: "d-flex align-items-center fs-6 form-label mb-2 text-dark-blue" }
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_20 = ["value", "onUpdate:modelValue", "disabled"]
const _hoisted_21 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-auto" }
const _hoisted_25 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_26 = ["value", "onUpdate:modelValue", "disabled"]
const _hoisted_27 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_28 = { class: "col-auto" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-3" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-3" }
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { key: 4 }
const _hoisted_41 = { class: "row mb-2" }
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 d-flex justify-content-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", null, "%")
], -1)
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { class: "row mb-2" }
const _hoisted_48 = { class: "col-lg-12" }
const _hoisted_49 = ["onUpdate:modelValue", "disabled"]
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = {
  key: 6,
  class: "text-danger d-flex flex-column"
}
const _hoisted_53 = { class: "d-flex flex-stack pt-10" }
const _hoisted_54 = { class: "mr-2" }
const _hoisted_55 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_56 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_57 = {
  type: "submit",
  class: "btn btn-lg btn-dark-blue me-3",
  ref: "submitButton"
}
const _hoisted_58 = { class: "indicator-label" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" })
], -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "indicator-progress" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_64 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_65 = { class: "pt-3" }
const _hoisted_66 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_integer_gender_field = _resolveComponent("integer-gender-field")!
  const _component_select_yes_no_field = _resolveComponent("select-yes-no-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_SurveyConfirmModal = _resolveComponent("SurveyConfirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args))),
      class: "survey-form"
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, [
            _createElementVNode("b", null, _toDisplayString(_ctx.step.id), 1),
            _createTextVNode("  " + _toDisplayString(_ctx.step[_ctx.translateKey("descrizione")]), 1)
          ]),
          _createElementVNode("div", {
            class: "text-gray-600 fw-bold fs-6 mt-5 header-bg p-5",
            innerHTML: _ctx.translate(_ctx.messages_survey[_ctx.step.id - 1])
          }, null, 8, _hoisted_4),
          (_ctx.step.id == 10)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, " (" + _toDisplayString(_ctx.$t("SURVEY_FULLY_OPTIONAL_SET")) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input_values_reduce, (input, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row mb-6",
              key: index
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SurveyService.getInputByIdGroup(
                input.input.set_id,
                input.input.id,
                _ctx.input_values_in_step
              ), (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (
                  _ctx.SurveyService.isInArray(
                    _ctx.setsHeaderList,
                    'after_kpi_number',
                    item.kpi.auto_number
                  )?.after_kpi_number > 0
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.SurveyService.isInArray(
                      _ctx.setsHeaderList,
                      "after_kpi_number",
                      item.kpi.auto_number
                    )[_ctx.translateKey("message")]), 1),
                        (item.kpi.auto_number == 76)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "text-gray-600 fw-bold fs-6 mt-5",
                              innerHTML: _ctx.$t('SURVEY_1_MESSAGE_COMPOSIZIONE_DIPENDENTI_STAFF_LINEA')
                            }, null, 8, _hoisted_9))
                          : _createCommentVNode("", true),
                        (item.kpi.auto_number == 187)
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_10, " (" + _toDisplayString(_ctx.$t("SURVEY_FULLY_OPTIONAL_SET")) + ") ", 1))
                          : _createCommentVNode("", true),
                        (item.kpi.auto_number == 163)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "text-gray-600 fw-bold fs-6 mt-5",
                              innerHTML: _ctx.$t('SURVEY_9_MESSAGE_CONGEDO_PARENTALE_PER_GENERE')
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass(!input.kpi.optional ? 'required' : ''),
                    style: {"font-weight":"400 !important"}
                  }, _toDisplayString(input.kpi.set_id) + "." + _toDisplayString(input.kpi.id) + " " + _toDisplayString(input.kpi[_ctx.translateKey("name")]), 3),
                  (input.kpi.description != 'VOID')
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "fas fa-exclamation-circle ms-2 fs-7",
                        "data-bs-toggle": "tooltip",
                        title: input.kpi[_ctx.translateKey('description')]
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  _createElementVNode("i", {
                    class: "fas fa-save ms-2 fs-7",
                    "data-bs-toggle": "tooltip",
                    title: 
                    _ctx.translate('SURVEY_LAST_MODIFIED_BY') +
                    ' `' +
                    _ctx.currentUser.user_name +
                    '` (' +
                    _ctx.currentUser.email +
                    ') ' +
                    _ctx.translate('SURVEY_TIME_LAST_MODIFICATION') +
                    ' ' +
                    input.input.timestamp_modification
                  
                  }, null, 8, _hoisted_15)
                ])
              ]),
              (input.kpi.type == _ctx.InputTypes.INTEGER_GENDER_FIELD)
                ? (_openBlock(), _createBlock(_component_integer_gender_field, {
                    key: 0,
                    input: input,
                    input_values_in_step: _ctx.input_values_in_step,
                    isActiveStep: _ctx.isActiveStep
                  }, null, 8, ["input", "input_values_in_step", "isActiveStep"]))
                : _createCommentVNode("", true),
              (input.kpi.type == _ctx.InputTypes.SELECT_YES_NO_FIELD)
                ? (_openBlock(), _createBlock(_component_select_yes_no_field, {
                    key: 1,
                    input: input,
                    input_values_in_step: _ctx.input_values_in_step,
                    isActiveStep: _ctx.isActiveStep
                  }, null, 8, ["input", "input_values_in_step", "isActiveStep"]))
                : _createCommentVNode("", true),
              (input.kpi.type == _ctx.InputTypes.ROLE_GENDER_FIELD)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Field, {
                        class: "form-check-input d-none",
                        type: "text",
                        name: 'input' + input.kpi.auto_number,
                        modelValue: input.input.value,
                        "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            value: _ctx.InputTypes.VALUE_WOMAN_FIELD,
                            "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event),
                            disabled: !_ctx.isActiveStep
                          }, null, 8, _hoisted_20), [
                            [_vModelRadio, input.input.value]
                          ]),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.translate("SURVEY_WOMAN_STRING")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'input' + input.kpi.auto_number
                            }, null, 8, ["name"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            value: _ctx.InputTypes.VALUE_MAN_FIELD,
                            "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event),
                            disabled: !_ctx.isActiveStep
                          }, null, 8, _hoisted_26), [
                            [_vModelRadio, input.input.value]
                          ]),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.translate("SURVEY_MAN_STRING")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("i", {
                          class: "fas fa-eraser ms-1 fs-2",
                          "data-bs-toggle": "tooltip",
                          title: "Info",
                          onClick: ($event: any) => (input.input.value = '')
                        }, null, 8, _hoisted_29)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (input.kpi.type == _ctx.InputTypes.FLOAT_GENDER_FIELD)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_Field, {
                          type: "number",
                          min: "0",
                          name: 
                      'input' +
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).kpi.auto_number
                    ,
                          disabled: !_ctx.isActiveStep,
                          class: "form-control form-control-lg",
                          modelValue: 
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).input.value
                    ,
                          "onUpdate:modelValue": ($event: any) => ((
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).input.value
                    ) = $event)
                        }, null, 8, ["name", "disabled", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_ErrorMessage, {
                              name: 
                          'input' +
                          _ctx.SurveyService.getSingleFloatIntegerGenderField(
                            input.input.set_id,
                            input.input.id,
                            _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                            _ctx.input_values_in_step
                          ).kpi.auto_number
                        
                            }, null, 8, ["name"])
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_Field, {
                          type: "number",
                          min: "0",
                          name: 
                      'input' +
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).kpi.auto_number
                    ,
                          class: "form-control form-control-lg",
                          modelValue: 
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).input.value
                    ,
                          "onUpdate:modelValue": ($event: any) => ((
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).input.value
                    ) = $event),
                          disabled: !_ctx.isActiveStep
                        }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_ErrorMessage, {
                              name: 
                          'input' +
                          _ctx.SurveyService.getSingleFloatIntegerGenderField(
                            input.input.set_id,
                            input.input.id,
                            _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                            _ctx.input_values_in_step
                          ).kpi.auto_number
                        
                            }, null, 8, ["name"])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (input.kpi.type == _ctx.InputTypes.PERCENTAGE_FIELD)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: 'input' + input.kpi.auto_number,
                          class: "form-control form-control-lg",
                          modelValue: input.input.value,
                          "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event),
                          disabled: !_ctx.isActiveStep
                        }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'input' + input.kpi.auto_number
                            }, null, 8, ["name"])
                          ])
                        ])
                      ]),
                      _hoisted_45
                    ])
                  ]))
                : _createCommentVNode("", true),
              (input.kpi.type == _ctx.InputTypes.TEXT_AREA_FIELD)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_Field, {
                          class: "form-check-input d-none",
                          type: "text",
                          name: 'input' + input.kpi.auto_number,
                          modelValue: input.input.value,
                          "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                        }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control form-control-lg",
                          "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event),
                          rows: "5",
                          disabled: !_ctx.isActiveStep
                        }, "\r\n                  ", 8, _hoisted_49), [
                          [_vModelText, input.input.value]
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_ErrorMessage, {
                              name: 'input' + input.kpi.auto_number
                            }, null, 8, ["name"])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getErrors(input.kpi.id, input.input.set_id).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getErrors(
                  input.kpi.id,
                  input.input.set_id
                ), (error, error_index) => {
                      return (_openBlock(), _createElementBlock("small", { key: error_index }, _toDisplayString(error[_ctx.translateKey("error")]), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          (_ctx.$route.params.step != 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-lg btn-dark-blue me-3",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
              }, [
                _createElementVNode("span", _hoisted_55, [
                  _createVNode(_component_inline_svg, {
                    src: "/media/icons/duotune/arrows/arr063.svg",
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_GO_BEHIND_BUTTON")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isActiveStep)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("button", _hoisted_57, [
                _createElementVNode("span", _hoisted_58, [
                  _hoisted_59,
                  (_ctx.$route.params.step == _ctx.totalSteps)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.translate("SURVEY_LAST_SET_SUBMIT_BUTTON")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.translate("SURVEY_SAVE_AND_CONTINUE_BUTTON")), 1))
                ]),
                _createElementVNode("span", _hoisted_62, [
                  _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                  _hoisted_63
                ])
              ], 512)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-lg btn-dark-blue",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.translate("SURVEY_GO_AHEAD_BUTTON")) + " ", 1),
            _createElementVNode("span", _hoisted_64, [
              _createVNode(_component_inline_svg, {
                src: "/media/icons/duotune/arrows/arr064.svg",
                "aria-hidden": "true"
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("small", _hoisted_66, _toDisplayString(_ctx.backendErrorMessage[_ctx.translateKey("error")]), 1)
      ])
    ], 32),
    _createVNode(_component_SurveyConfirmModal, {
      ref: "surveyConfirmModalRef",
      submitSurveyInput: _ctx.submitSurveyInput
    }, null, 8, ["submitSurveyInput"])
  ]))
}